import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Buyer } from 'src/app/core/buyers.service';

@Component({
  selector: 'app-buyer-details-general-residency',
  templateUrl: './buyer-details-general-residency.component.html',
  styleUrls: ['./buyer-details-general-residency.component.scss'],
})
export class BuyerDetailsGeneralResidencyComponent {
  @Input() buyer?: Buyer;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
}
